import { Button, Popconfirm, Tooltip } from 'antd';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import dayjs from 'dayjs'

const Columns = ({ handleEditTask, handleRemoveTask, issueAreas, taskStatus, isSuperuser, hasAnyRole, canGapsUpdate }) => {
  const getStatusName = (statusId) => {
    const status = taskStatus?.find(s => s.id === statusId);
    return status ? status.name : '';
  };

  const getAreaName = (areaId) => {
    const area = issueAreas?.find(a => a.id === areaId);
    return area ? area.name : '';
  };

  return [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      onHeaderCell: () => ({ 
        style: { 
          backgroundColor: '#E0F8AD', 
          color: '#006939', 
          fontWeight: 'bold' 
        } 
      }),
      render: (text) => <span>{text}</span>,
      width: '25%'
    },
    {
      title: 'Fecha Comprometida',
      dataIndex: 'date_committed',
      key: 'date_committed',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' }
      }),
      render: (date_committed) =>
        date_committed
          ? dayjs(date_committed).format('DD/MM/YYYY')
          : 'No especificada',
      width: '25%'
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
      onHeaderCell: () => ({ 
        style: { 
          backgroundColor: '#E0F8AD', 
          color: '#006939', 
          fontWeight: 'bold' 
        } 
      }),
      render: (status) => (
        <span>{status?.name || getStatusName(status?.index)}</span>
      ),
      width: '15%'
    },
    {
      title: 'Comentarios',
      dataIndex: 'comments',
      key: 'comments',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (comments) =>
        comments?.length ? (
          <Tooltip
            title={
              comments.map((c, i) => (
                <div key={i}>
                  • {c.comment.length > 15
                    ? `${c.comment.slice(0, 15)}...`
                    : c.comment}
                </div>
              ))
            }
          >
            {comments.length} comentario(s)
          </Tooltip>
        ) : '0',
      align: 'center'
    },
    {
      title: 'Responsable',
      dataIndex: 'responsible_area',
      key: 'responsible_area',
      onHeaderCell: () => ({ 
        style: { 
          backgroundColor: '#E0F8AD', 
          color: '#006939', 
          fontWeight: 'bold' 
        } 
      }),
      render: (responsible_area) => (
        <span>{responsible_area?.name || getAreaName(responsible_area?.id)}</span>
      ),
       width: '20%'
    },
    {
      title: 'Acciones',
      key: 'action',
      align: 'center',
      onHeaderCell: () => ({ 
        style: { 
          backgroundColor: '#E0F8AD', 
          color: '#006939', 
          fontWeight: 'bold',
          textAlign: 'center'
        } 
      }),
      render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button
            type="link" 
            disabled={!isSuperuser && (!hasAnyRole || !canGapsUpdate)}
            style={{ 
              color: (!isSuperuser && (!hasAnyRole || !canGapsUpdate)) ? '#999999' : '#006939', 
              fontSize: 18,  
              padding: '0px 2px'
            }}
            onClick={() => handleEditTask(record)}
          >
            <Tooltip title="Editar Tarea"><EditFilled /></Tooltip>
          </Button>
          
          {/* <Popconfirm 
            overlayClassName="custom-popconfirm"
            title="¿Seguro que deseas eliminar esta Tarea?"
            onConfirm={() => handleRemoveTask(record.id)}
            disabled={!isSuperuser && (!hasAnyRole || !canGapsUpdate)}
          >
            <Button 
              type="link"
              disabled={!isSuperuser && (!hasAnyRole || !canGapsUpdate)}
              style={{ 
                color: (!isSuperuser && (!hasAnyRole || !canGapsUpdate)) ? '#999999' : '#006939', 
                fontSize: 18,  
                padding: '0px 2px'
              }}
            >
              <Tooltip title="Eliminar tarea"><DeleteFilled /></Tooltip>
            </Button>
          </Popconfirm> */}
        </div>
      ),
      width: '10%',
    },
  ];
};

export default Columns;